import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceinvelhepune() {



  const cardData =
  {
    keyword: 'Cab Service in Velhe Pune',
    heading: 'Sanavi Travels: Cab Service in Velhe Pune',
    headingDescription: 'Cab Service in Velhe Pune offers reliable, safe, and comfortable taxi services for local travel, outstation trips, airport transfers, and special occasions such as weddings, corporate travel, and religious tours. Choose from a wide range of well-maintained vehicles including Swift Dzire, Etios, Ertiga, Innova Crysta, and SUVs, driven by professional and courteous chauffeurs. With on-time pickups, transparent pricing, flexible cab packages, doorstep service, and 24/7 booking support, cab service in Velhe Pune ensures a smooth, hassle-free, and pleasant travel experience to Pune city, Mumbai, Mahabaleshwar, Konkan, Goa, and other popular destinations.',

    top: 'Top Places to Visit in Velhe with Sanavi Travels',


"topPlaces": [
  {
    "title": "Velhe Town",
    "description": "Velhe is a scenic taluka in Pune district, nestled deep within the Sahyadri mountain ranges. Known for its untouched natural beauty, dense forests, and rich monsoon landscapes, Velhe is a paradise for nature lovers and trekkers. The region remains less commercialized, offering a peaceful environment and an authentic rural Maharashtrian experience."
  },
  {
    "title": "Torna Fort (Prachandagad)",
    "description": "Torna Fort, also known as Prachandagad, is the highest fort in Pune district and holds immense historical importance as the first fort captured by Chhatrapati Shivaji Maharaj. The fort features massive ramparts, temples, water tanks, and wide plateaus. Trekking to Torna is challenging yet rewarding, offering breathtaking views of the Sahyadri ranges and surrounding valleys."
  },
  {
    "title": "Rajgad Fort",
    "description": "Rajgad Fort, once the capital of the Maratha Empire, is one of the most significant forts near Velhe. The fort is famous for its majestic structures like Balekilla, Padmavati Machi, and Suvela Machi. It offers a powerful blend of history, architecture, and natural beauty, attracting trekkers, historians, and photography enthusiasts."
  },
  {
    "title": "Madhe Ghat",
    "description": "Madhe Ghat is a scenic mountain pass near Velhe, known for its lush greenery, deep valleys, and seasonal waterfalls. During the monsoon, the ghat transforms into a misty wonderland, making it a popular route for nature drives and photography."
  },
  {
    "title": "Velhe Forest Trails",
    "description": "The dense forests around Velhe are ideal for nature walks, birdwatching, and exploration. These trails pass through rich biodiversity zones, offering sightings of native flora and fauna, and providing a serene escape into nature."
  },
  {
    "title": "Temghar Dam (Nearby)",
    "description": "Located close to Velhe, Temghar Dam is a beautiful reservoir surrounded by hills and greenery. It is an ideal spot for scenic drives, sunset views, and quiet reflection, especially during the monsoon season."
  },
  {
    "title": "Monsoon Waterfalls",
    "description": "Velhe comes alive during the monsoon with numerous seasonal waterfalls cascading down cliffs and hillsides. These waterfalls enhance the region’s raw beauty and attract photographers and nature enthusiasts."
  },
  {
    "title": "Village Life and Rural Culture",
    "description": "The villages in Velhe taluka showcase traditional Maharashtrian rural life. Visitors can experience local farming practices, folk culture, simple cuisine, and warm hospitality, making it ideal for rural and eco-tourism."
  },
  {
    "title": "Trekking Base Villages",
    "description": "Velhe serves as a base region for several historic fort treks. Base villages provide food, guidance, and accommodation for trekkers heading to forts like Torna and Rajgad, adding to the region’s trekking ecosystem."
  },
  {
    "title": "Sunrise and Valley Viewpoints",
    "description": "High points around Velhe offer stunning sunrise views and sweeping panoramas of valleys and hills. These viewpoints are perfect for meditation, photography, and soaking in the untouched beauty of the Sahyadri ranges."
  }
]
,



"services": [
{
"name": "Cab Service in Velhe Pune",
"description": "Cab Service in Velhe Pune offers reliable and comfortable taxi services for local travel, sightseeing, and outstation trips. With well-maintained vehicles, professional drivers, and flexible booking options, it ensures a smooth, safe, and timely journey. Ideal for families, tourists, corporate travelers, and daily commuters, it provides personalized service, convenient pickup and drop options, and a hassle-free travel experience across Velhe and nearby areas."
},
{
"name": "Taxi Service Velhe",
"description": "Taxi Service Velhe delivers efficient and professional cab services for city travel, airport transfers, and long-distance trips. With courteous drivers, modern vehicles, and punctual service, it ensures convenient, safe, and comfortable transportation for residents, tourists, and business travelers in Velhe and surrounding regions."
},
{
"name": "AC Cab Velhe",
"description": "AC Cab Velhe provides fully air-conditioned taxis for a comfortable and relaxing travel experience. Perfect for long-distance trips, family outings, corporate travel, and tourist journeys, these cabs offer smooth rides, modern interiors, and professional drivers who prioritize safety, convenience, and passenger satisfaction."
},
{
"name": "Local Cab Velhe",
"description": "Local Cab Velhe offers reliable and timely taxi services within Velhe for shopping trips, sightseeing, errands, and daily commuting. With well-maintained vehicles, experienced drivers, and flexible scheduling, it ensures a safe, convenient, and hassle-free travel experience for passengers navigating the city."
},
{
"name": "Outstation Cab Velhe",
"description": "Outstation Cab Velhe specializes in long-distance travel to nearby cities, tourist destinations, and weekend getaways. With comfortable vehicles, skilled drivers, and flexible itineraries, it ensures safe, convenient, and enjoyable journeys for families, groups, and solo travelers venturing outside Velhe."
},
{
"name": "Affordable Cab Velhe",
"description": "Affordable Cab Velhe provides budget-friendly taxi services without compromising on comfort, safety, or reliability. Ideal for families, tourists, corporate travelers, and daily commuters, it combines economical pricing with professional drivers and well-maintained vehicles, making it a dependable choice for cost-conscious passengers in Velhe."
},
{
"name": "Chauffeur Driven Cab Velhe",
"description": "Chauffeur Driven Cab Velhe offers professional drivers who handle navigation, traffic, and schedules, allowing passengers to enjoy a stress-free journey. Perfect for VIP clients, corporate teams, families, and tourists, it ensures smooth, safe, and comfortable travel throughout Velhe and nearby areas."
},
{
"name": "Best Cab Service Velhe",
"description": "Best Cab Service Velhe is renowned for punctuality, well-maintained vehicles, and excellent customer service. Offering city travel, airport transfers, sightseeing, and outstation trips, it provides reliable, safe, and comfortable transportation for individuals, families, and corporate clients in and around Velhe."
},
{
"name": "Tourist Cab Velhe",
"description": "Tourist Cab Velhe caters to travelers exploring Velhe and nearby attractions. With flexible itineraries, knowledgeable drivers, and comfortable vehicles, it provides a seamless sightseeing experience, allowing tourists to enjoy cultural, historical, and scenic destinations without worrying about transportation logistics."
},
{
"name": "Picnic Cab Velhe",
"description": "Picnic Cab Velhe specializes in transportation for group outings, school trips, family picnics, and leisure excursions. With spacious vehicles, experienced drivers, and flexible routes, it ensures a safe, fun, and convenient travel experience for passengers planning recreational trips in and around Velhe."
},
{
"name": "Weekend Trip Cab Velhe",
"description": "Weekend Trip Cab Velhe offers comfortable and reliable taxi services for short getaways and weekend excursions. Perfect for families, friends, and corporate groups, it provides well-maintained vehicles, professional drivers, and flexible travel schedules to make weekend trips stress-free and enjoyable."
},
{
"name": "Online Cab Booking Velhe",
"description": "Online Cab Booking Velhe allows passengers to reserve cabs quickly and conveniently with instant confirmation. Offering multiple vehicle options, transparent pricing, and flexible scheduling, it simplifies travel planning for families, tourists, corporate clients, and local commuters traveling to or from Velhe."
},
{
"name": "Family Cab Velhe",
"description": "Family Cab Velhe provides spacious and comfortable vehicles suitable for family travel. Designed to accommodate passengers of all ages, it ensures safe, convenient, and enjoyable journeys for family outings, vacations, and day trips within Velhe and nearby areas."
},
{
"name": "Corporate Cab Velhe",
"description": "Corporate Cab Velhe delivers professional and efficient taxi services for executives, employees, and business teams. With punctual pickups, clean vehicles, and courteous drivers, it ensures safe, reliable, and stress-free transportation for office travel, meetings, airport transfers, and corporate events in Velhe."
},
{
"name": "Velhe Travel Taxi",
"description": "Velhe Travel Taxi provides comprehensive cab services for local commuting, tourist travel, and outstation trips. Combining comfort, safety, affordability, and professional service, it caters to families, tourists, and corporate travelers seeking dependable and convenient transportation in Velhe and surrounding areas."
}
],
"tableData": [
["Cab Service in Velhe Pune", "Taxi Service Velhe"],
["AC Cab Velhe", "Local Cab Velhe"],
["Outstation Cab Velhe", "Affordable Cab Velhe"],
["Chauffeur Driven Cab Velhe", "Best Cab Service Velhe"],
["Tourist Cab Velhe", "Picnic Cab Velhe"],
["Weekend Trip Cab Velhe", "Online Cab Booking Velhe"],
["Family Cab Velhe", "Corporate Cab Velhe"],
["Velhe Travel Taxi", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Cab Service in Velhe Pune with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers reliable and comfortable cab services in Velhe Pune for local travel, airport transfers, sightseeing, and outstation trips."
  },
  {
    "WhyChooseheading": "Clean and Well‑Maintained Cabs",
    "WhyChoosedescription": "Our cabs are regularly serviced, air‑conditioned, and kept clean to ensure a smooth and pleasant ride throughout Velhe Pune."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed and courteous drivers are familiar with Velhe Pune routes and nearby areas, ensuring safe, timely, and stress‑free travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides clear and upfront pricing for all cab services in Velhe Pune, including fuel and toll charges, with no hidden fees."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our customer support team is available round the clock to assist with cab bookings, travel queries, and itinerary planning."
  },
  {
    "WhyChooseheading": "Flexible Ride Options",
    "WhyChoosedescription": "Choose from local rides, hourly hires, airport transfers, and outstation cab packages based on your travel needs."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All cabs are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On‑Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for cab service in Velhe Pune."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide cab services in Velhe Pune?',
    answer: 'Yes, Sanavi Travels offers dependable cab services in Velhe Pune for local and outstation travel.'
  },
  {
    question: 'How can I book a cab in Velhe Pune?',
    answer: 'You can easily book a cab through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of cab services are available in Velhe Pune?',
    answer: 'Sanavi Travels offers local rides, airport transfers, hourly hires, and outstation cab services in Velhe Pune.'
  },
  {
    question: 'Are the drivers experienced with routes in Velhe Pune?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with the Velhe Pune area and nearby routes.'
  },
  {
    question: 'Can I choose custom pickup and drop‑off locations?',
    answer: 'Absolutely. You can select your preferred pickup and drop‑off locations anywhere in Velhe Pune.'
  },
  {
    question: 'Is the cab service in Velhe Pune available 24x7?',
    answer: 'Yes, Sanavi Travels offers round‑the‑clock cab services in Velhe Pune to suit your travel schedule.'
  },
  {
    question: 'Are the cabs sanitized before every trip?',
    answer: 'Yes, all cabs are thoroughly cleaned and sanitized to ensure a safe and hygienic travel experience.'
  },
  {
    question: 'What payment options are available for cab services?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments for cab bookings.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your cab ride in Velhe Pune.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rohit More',
    feedback: 'Booked a cab in Velhe Pune with Sanavi Travels — excellent service, clean vehicle, and friendly driver.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Priya Shinde',
    feedback: 'Great cab experience with Sanavi Travels in Velhe Pune — prompt pickup and comfortable ride!',
    rating: 5
  }
];

























































































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "Taxi",
  "name": "Cab Service in Velhe Pune - Sanavi Travels",
  "description": "Sanavi Travels offers reliable cab services in Velhe Pune including AC, local, outstation, and chauffeur-driven taxis. Perfect for family trips, weekend getaways, corporate travel, and tourist sightseeing. Online booking available.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "30"
  }
};







  return (
    <div>
<Helmet>
  <title>
    Cab Service in Velhe Pune | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Hire AC, local, and outstation cabs in Velhe Pune with Sanavi Travels. Ideal for family trips, weekend getaways, corporate travel, and sightseeing. Chauffeur-driven service and online booking available."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/146.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Cabserviceinvelhepune;